import { useSelector } from "react-redux";
import { useMatch } from "react-router";
import { RootState } from "src/store";
import { ROUTES_URL } from "src/utils/constants";
import { useProjectsPageT } from "src/translation-hooks/projects-page";
import { usePriceListPageT } from "src/translation-hooks/price-list-page";
import { useContactPageT } from "src/translation-hooks/contact-page";
import { useFaqPageT } from "src/translation-hooks/faq-page";
import { useInformationPageT } from "src/translation-hooks/information-page";
import { useProfileSettingsPageT } from "src/translation-hooks/profile-settings-page";
import { InformationTabsValue } from "src/pages/information/information-types";

type BreadcrumbItem = { label: string; path?: string };

export const useBreadcrumbs = (): BreadcrumbItem[] => {
  const projectListState = useSelector((state: RootState) => state.pageReducer.projectListReducer.projectListState);
  const configurationsState = useSelector((state: RootState) => state.pageReducer.combinedConfiguratorReducer.configuratorReducer.configurationsState);
  const productState = useSelector((state: RootState) => state.pageReducer.productDetailsReducer.productState);

  const configuratorMatch = useMatch(ROUTES_URL.CONFIGURATOR.pattern);
  const informationMatch = useMatch(ROUTES_URL.INFORMATION.pattern);
  const productDetailsMatch = useMatch(ROUTES_URL.PRODUCT_DETAILS.pattern);
  const projectsMatch = useMatch(ROUTES_URL.PROJECTS);
  const priceListMatch = useMatch(ROUTES_URL.PRICE_LIST);
  const profileMatch = useMatch(ROUTES_URL.PROFILE);
  const faqMatch = useMatch(ROUTES_URL.FAQ);
  const contactMatch = useMatch(ROUTES_URL.CONTACT);

  const projectsPageT = useProjectsPageT();
  const priceListPageT = usePriceListPageT();
  const contactPageT = useContactPageT();
  const faqPageT = useFaqPageT();
  const informationPageT = useInformationPageT();
  const profileSettingsPageT = useProfileSettingsPageT();

  if (configuratorMatch) {
    const projectName = configurationsState ? configurationsState.projectDescription : "";
    const projectName2 = projectListState.loading === "has-loaded" ? projectListState.data.find(p => p.projectId === configuratorMatch.params.projectId)?.description || "" : "";
    return [{ label: projectsPageT.projects, path: ROUTES_URL.PROJECTS }, { label: projectName2 || projectName }];
  }
  if (projectsMatch) return [{ label: projectsPageT.projects }];
  if (productDetailsMatch) {
    const productName = productState.loading === "has-loaded" ? productState.data.description : "";
    return [{ label: priceListPageT.pricelist, path: ROUTES_URL.PRICE_LIST }, { label: productName }];
  }
  if (priceListMatch) return [{ label: priceListPageT.pricelist }];
  if (informationMatch) {
    const tab = informationMatch.params.currentTab as InformationTabsValue;
    return [{ label: informationPageT[tab] ?? informationPageT.information }];
  }
  if (profileMatch) return [{ label: profileSettingsPageT.profileSettings }];
  if (faqMatch) return [{ label: faqPageT.faq }];
  if (contactMatch) return [{ label: contactPageT.contact }];

  return [];
};
